export class ScanResult {
  barcode1 = ''
  barcode2 = ''
  batch = ''
  expiry = ''
  id = ''
  itemCode = ''
  mfg = ''
  mrp = ''
  obatch = ''
  optional1 = ''
  optional2 = ''
  scannedImage = ''
  searchType = ''
  session_id = ''
  sku = ''
  status = ''
  lrDate = ''
  remark = ''
  recDate = ''
  clientCode = ''
  clientName = ''
  region = ''
  platform = ''
}

export class ScanResultQueue {
  items = []
  processingItems = []
  constructor() {}

  addItem(item, id) {
    const index = this.items.findIndex((existingItem) => id == existingItem.id)
    // console.log(`index = ${index}`)
    if (index != -1) {
      // console.log('item already exists')
      return null
    }

    const indexProcessing = this.processingItems.findIndex(
      (existingItem) => id == existingItem.id
    )

    // console.log(`indexProcessing = ${indexProcessing}`)
    if (indexProcessing != -1) {
      // console.log('item already processing')
      return null
    }

    // console.log('adding new item : ', id)

    const result = new ScanResult()
    // console.log('result ====>', item)
    result.barcode1 = item['barcode1'] ? item['barcode1'] : 'nan'
    result.barcode2 = item['barcode2'] ? item['barcode2'] : 'nan'
    result.batch = item['batch'] ? item['batch'] : ''
    result.expiry = item['expiry'] ? item['expiry'] : 'nan'
    result.id = id
    result.itemCode = item['itemCode'] ? item['itemCode'] : ''
    result.mfg = item['mfg'] ? item['mfg'] : 'nan'
    result.mrp = item['mrp'] ? item['mrp'] : ''
    result.obatch = item['obatch'] ? item['obatch'] : ''
    result.optional1 = item['optional1'] ? item['optional1'] : ''
    result.optional2 = item['optional2'] ? item['optional2'] : ''
    result.scannedImage = item['scannedImage'] ? item['scannedImage'] : ''
    result.searchType = item['searchType'] ? item['searchType'] : 'nan'
    result.session_id = item['session_id'] ? item['session_id'] : 'nan'
    result.sku = item['sku'] ? item['sku'] : ''
    result.status = item['status'] ? item['status'] : 'nan'
    result.lrDate = item['lrDate'] ? item['lrDate'] : 'nan'
    result.recDate = item['recDate'] ? item['recDate'] : 'nan'
    result.remark = item['remark'] ? item['remark'] : 'nan'
    result.clientCode = item['clientCode'] ? item['clientCode'] : 'nan'
    result.clientName = item['clientName'] ? item['clientName'] : 'nan'
    result.region = item['region'] ? item['region'] : 'nan'
    result.platform = item['platform'] ? item['platform'] : 'nan'
    // console.log('result ====>', result)

    this.items.unshift(result)
    return result
  }

  allItems() {
    const list = []
    for (const item of this.items) {
      list.unshift(item)
    }

    for (const item of this.processingItems) {
      list.unshift(item)
    }

    return list
  }

  clearProcessingQueue() {
    this.processingItems = []
  }

  popItem() {
    // wait till we are done with the previous item
    if (this.processingItems.length > 0) {
      return null
    }

    this.processingItems = []
    if (this.items.length > 0) {
      const item = this.items.shift()
      this.processingItems.push(item)
      return item
    }

    this.poppedItemKey = null
    return null
  }

  itemCount() {
    if (this.items.length == 0) {
      this.processingItems = []
    }

    return this.items.length
  }
}

export const scanResultQueue = new ScanResultQueue()
